import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { LanguageProvider } from "@/context/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Products } from "@/components/Products";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    window.__lenis = lenis;

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <LanguageProvider>
      <div className="App relative min-h-screen bg-[#F9F9F8] text-[#111111] antialiased grain">
        <Navbar />
        <main>
          <Hero />
          <EditorialMarquee />
          <Products />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
